// removed by extract-text-webpack-plugin
module.exports = {"noteWrapper":"_2N7WuNnqWLTRchFGoE9zbE","noteContent":"_3gAwHkDKpFXTnptkY_09c1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notes/NoteInput.scss
// module id = 771
// module chunks = 0